import { FC } from 'react';
import { Listbox } from '@headlessui/react';
import { ReactComponent as DropdownIcon } from 'assets/icons/chevron-down.svg';

export interface SelectDropdownOption {
  value: string | number;
  label: string;
}

interface SelectDropdownProps {
  options: SelectDropdownOption[];
  value: string | number;
  onChange: (value: string | number) => void;
  placeholder?: string;
  listBoxButtonClassName?: string;
}

const SelectDropdown: FC<SelectDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select',
  listBoxButtonClassName,
}) => {
  const selectedOption = options.find((option) => option.value === value);

  return (
    <Listbox value={value} onChange={onChange}>
      {({ open }) => (
        <div className="relative text-14 leading-[2.1rem]">
          <Listbox.Button
            className={`relative w-full h-[4.8rem] pl-1.6 cursor-pointer rounded-[1rem] bg-white border-[0.5px] border-light-grey text-left shadow-primary hover:border-magenta hover:shadow-input-active outline-none ${
              open ? 'border-magenta shadow-input-active' : ''
            } ${listBoxButtonClassName ?? ''}`}
          >
            <span
              className={`block pr-3 ${
                selectedOption ? 'text-darkest-grey' : 'text-mid-grey'
              }`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <DropdownIcon className="w-1.4 h-1.4" />
            </span>
          </Listbox.Button>
          <Listbox.Options className="absolute mt-0.5 max-h-16 scrollbar w-full overflow-auto rounded-[0.8rem] bg-white py-1.5 text-base shadow-primary flex flex-col gap-y-1.5 z-10">
            {options.map((option) => (
              <Listbox.Option
                key={option.value}
                className="relative cursor-default select-none pl-1.6"
                value={option.value}
              >
                <span
                  className={`block truncate cursor-pointer hover:text-magenta ${
                    value === option.value ? 'text-magenta' : ''
                  }`}
                >
                  {option.label}
                </span>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      )}
    </Listbox>
  );
};

export default SelectDropdown;
